/* src/app/ship/address-dialogs/residential-access-point-suggestion-dialog/residential-access-point-suggestion-dialog.component.scss */
.dialog-header .mat-mdc-dialog-title {
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
  color: #000000;
  padding: 0;
}
.dialog-header .close-icon {
  position: absolute;
  top: 0;
  right: 0;
}
.dialog-content {
  padding: 0.5rem 0 0;
}
.dialog-content p {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.5rem;
  color: #000000;
  margin-bottom: 1.5rem;
}
.dialog-content p:not(:last-of-type) {
  margin-bottom: 0.5rem;
}
.dialog-content p1 {
  font-size: 0.9375rem;
}
.dialog-content p2 {
  font-size: 0.75rem;
}
.dialog-content .actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-around;
  flex-wrap: wrap;
}
.dialog-content .actions .mat-mdc-button-base {
  width: 100%;
  height: 2.1875rem;
  border-radius: 0.25rem;
  font-size: 0.625rem;
  font-weight: 600;
  line-height: 0.9375rem;
  border: solid thin #0A8080;
}
@media screen and (min-width: 48rem) {
  .dialog-content .actions .mat-mdc-button-base {
    width: 10.75rem;
  }
}
.dialog-content .actions .mat-mdc-button-base.mat-mdc-raised-button {
  font-weight: 300;
}
:host(.residential-access-point-suggestion-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  position: relative;
  padding: 1.5rem 2.5rem;
}
@media screen and (min-width: 48rem) {
  :host(.residential-access-point-suggestion-dialog) {
    height: auto;
    width: 33.625rem;
    min-width: 21.5rem;
  }
}
/*# sourceMappingURL=residential-access-point-suggestion-dialog.component.css.map */
